import {
  CREATE_SHARE_PAGE_URL
} from 'app/utils/Constants';

import {
  post
} from 'shared/services/ApiService';

export const createSharePage = (token, moment_ids) => {
  let params = { moment_ids };
  return post(CREATE_SHARE_PAGE_URL(token), params);
}

